import { render, staticRenderFns } from "./BaseTags.vue?vue&type=template&id=bcd3a8a0&"
import script from "./BaseTags.vue?vue&type=script&lang=js&"
export * from "./BaseTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports